import { ROUTES } from 'dictionary/routes';

export default function refreshSite() {
  const pathname = window.location.pathname;
  const restrictedURLs = [ROUTES.NOT_FOUND, ROUTES.ERROR, ROUTES.LOGOUT];

  const forceRedirectHome = restrictedURLs.some((url) =>
    pathname.includes(url),
  );

  if (forceRedirectHome) {
    window.location.href = ROUTES.ROOT;
    return;
  }

  window.location.reload();
}
